<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="客户"
      class="customer-edit"
      width="500px"
      top="3vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="customer"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-form-item label="客户名字">
        <el-input v-model="customer.name" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="联系人">
        <el-input v-model="customer.contactName" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="手机号" prop="contactPhone">
        <el-input v-model="customer.contactPhone" placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import regular from "@/util/regular";

  export default {
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        customer: {
          id: 0,
          name: "",
          contactPhone: "",
          contactName: "",

        },
        ruleValidate: {
          contactPhone: {
            required: true,
            pattern: regular.phone,
            trigger: "blur",
            message: "手机号格式不正确",
          },
        },
      };
    },
    methods: {
      open(id) {
        this.customer.id = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `customers/${this.customer.id}`)
          .then(resp => {
            this.customer = resp.data;
          });
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "customers", this.customer)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
